import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { CONTACT_EMAIL } from "@/lib/brand";
import { useSiteLanguage } from "@/lib/useSiteLanguage";
import { legalChromeCopy, termsBodyCopy } from "@/lib/siteCopy";

export function TermsPage() {
  const lang = useSiteLanguage();
  const t = legalChromeCopy[lang];
  const h = t.termsHeadings;
  const b = termsBodyCopy[lang];
  const domain = "devdotcom.org";

  return (
    <>
      <SEO
        title="Terms & Conditions | DevDotCom"
        description="Terms governing use of the DevDotCom website and related services."
        keywords="terms and conditions, DevDotCom terms of use"
      />
      <section className="bg-background px-5 pb-20 pt-28 sm:px-6 sm:pb-24 sm:pt-32 lg:px-10">
        <div className="mx-auto max-w-3xl">
          <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
            {t.eyebrow}
          </p>
          <h1 className="mt-3 text-4xl font-bold tracking-tight sm:text-5xl">
            {t.termsTitle}
          </h1>
          <p className="mt-4 text-muted-foreground">{t.lastUpdated}</p>

          <div className="mt-10 space-y-8 text-[15px] leading-relaxed text-foreground/90">
            <section>
              <h2 className="text-xl font-semibold tracking-tight">{h.agreement}</h2>
              <p className="mt-2 text-muted-foreground">
                {b.agreement.split("{domain}")[0]}
                <span className="text-foreground">{domain}</span>
                {b.agreement.split("{domain}")[1]}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold tracking-tight">
                {h.services}
              </h2>
              <p className="mt-2 text-muted-foreground">{b.services}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold tracking-tight">
                {h.ip}
              </h2>
              <p className="mt-2 text-muted-foreground">{b.ip}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold tracking-tight">
                {h.acceptable}
              </h2>
              <ul className="mt-2 list-disc space-y-2 pl-5 text-muted-foreground">
                {b.acceptable.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold tracking-tight">
                {h.disclaimers}
              </h2>
              <p className="mt-2 text-muted-foreground">{b.disclaimers}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold tracking-tight">
                {h.thirdParty}
              </h2>
              <p className="mt-2 text-muted-foreground">{b.thirdParty}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold tracking-tight">{h.changes}</h2>
              <p className="mt-2 text-muted-foreground">{b.changes}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold tracking-tight">{h.contact}</h2>
              <p className="mt-2 text-muted-foreground">
                {b.contactBefore}{" "}
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="font-medium text-foreground underline underline-offset-4"
                >
                  {CONTACT_EMAIL}
                </a>
                . {b.contactOr}{" "}
                <Link
                  to="/contact"
                  className="font-medium text-foreground underline underline-offset-4"
                >
                  {t.contactLink}
                </Link>{" "}
                {b.contactAfter}
              </p>
            </section>
          </div>
        </div>
      </section>
    </>
  );
}
